import type { MapViewOptions } from "./map-view-options";

export const DEFAULT_MAP_OPTIONS: google.maps.MapOptions = {
  disableDefaultUI: true,
  zoomControl: true,
  mapTypeId: 'satellite',
  maxZoom: 40,
};

export const DEFAULT_ZOOM = 15;

export const DEFAULT_MAP_VIEW_OPTIONS: MapViewOptions = {
  satellite: true,
  defaultZoom: DEFAULT_ZOOM,
  maxZoom: 40,
};
export const MIN_HEIGHT = 300;
export const MAX_HEIGHT = 1200;
export const DEFAULT_HEIGHT = 700;

export const ZOOM_LIMITS = {
  SMALL_MAP: 13,
  SINGLE_POINT: 15,
  MAX_ZOOM: 18,
  DEFAULT: 12,
  SMALL_MAP_DEFAULT: 10,
};

export const POLYLINE_STYLE = {
  strokeOpacity: 0.8,
  strokeWeight: 2,
  geodesic: true,
};

export const POLYGON_STYLE = {
  basic: {
    fillOpacity: 0.2,
    hoverFillOpacity: 0.4,
  },
  polygon: {
    fillOpacity: 0.1,
    hoverFillOpacity: 0.3,
  },
  strokeOpacity: 0.8,
  strokeWeight: 2,
  hoverStrokeWeight: 3,
};

export const MARKER_STYLE = {
  defaultColor: "#EF4444",
  sizes: {
    normal: 6,
    last: 12,
  },
};

/** GPS heatmap (simpleheat canvas overlay) tuning.
 * `radius`/`blur` are in screen pixels; `max` is the accumulated point value
 * that maps to full intensity (lower = saturates with fewer overlapping
 * points); `opacity` is the whole-layer canvas opacity; `gradient` maps a
 * 0–1 intensity stop to a CSS color. The first stop must be low so faint areas
 * render blue rather than translucent black (simpleheat's default gradient is
 * transparent below 0.4). */
export const HEATMAP_STYLE = {
  radius: 22,
  blur: 18,
  max: 3,
  opacity: 0.8,
  gradient: {
    0.1: "#2c7bb6", // blue (coolest)
    0.35: "#00ccbc", // cyan
    0.55: "#7bdf3c", // green
    0.75: "#fdae61", // orange
    1.0: "#d7191c", // red (hottest)
  } as Record<number, string>,
};

/** Google Maps JS API libraries. Shared by EVERY <GoogleMap> mount site so the
 * loader builds one identical script URL (it dedupes by exact URL). */
export const MAP_LIBRARIES = ["places", "geometry"];
